import { Component, Input } from '@angular/core';
import { ChartConfiguration, ChartOptions } from 'chart.js';
import { UserStepService } from 'src/app/services/user-step.service';

@Component({
  selector: 'app-weekly-report-chart-fit',
  templateUrl: './weekly-report-chart-fit.component.html',
  styleUrls: ['./weekly-report-chart-fit.component.scss']
})
export class WeeklyReportChartFitComponent {
  @Input() weeksData:any;

  public lineChartData: ChartConfiguration<'line'>['data'] = {
    
    labels: [
    ],
    datasets: [
      {
        data: [  ],
        label: 'Total Minutes',
        fill: false,
        tension: 0.5,
        borderColor: '#01E5BE',
        borderWidth:2,
        backgroundColor: 'rgba(0,0,0,0)',
        pointBackgroundColor:'#01E5BE',
        pointBorderColor:'#01E5BE',
      },
      {
        data: [  ],
        label: 'Moderate Intensity Minutes',
        fill: false,
        tension: 0.5,
        borderColor: '#EF9742',
        borderWidth:2,
        backgroundColor: 'rgba(0,0,0,0)',
        pointBackgroundColor:'#EF9742',
        pointBorderColor:'#EF9742',
      },
      {
        data: [  ],
        label: 'Vigorous Intensity Minutes',
        fill: false,
        tension: 0.5,
        borderColor: '#E54B38',
        borderWidth:2,
        backgroundColor: 'rgba(0,0,0,0)',
        pointBackgroundColor:'#E54B38',
        pointBorderColor:'#E54B38',
      }
    ]
  };
  public lineChartOptions: ChartOptions<'line'> = {
    responsive: true,
    plugins:{
      legend:{
        position:'bottom'
      }
    },
    scales:{
      y:{
        type: 'linear',
        display: true,
        position: 'left',
        suggestedMax: 7,
        suggestedMin: 0,
        beginAtZero:true,
        title: {
          display: true,
          text: "MINUTES PER WEEK",
          font: {
            size: 12,
            family: "Poppins",
            weight:"bold"
          },
        },
        ticks: {
          font: {
            size: 12,
            family: "Poppins",
          },
        },
        grid: {
          display:false
        }
      },
      x:{
        display: true,
        title: {
          display: true,
          text: "WEEK NUMBER",
          font: {
            size: 12,
            family: "Poppins",
            weight:"bold"
          },
        },
        ticks: {
          font: {
            size: 12,
            family: "Poppins",
          },
        },
        grid: {
          display:false
        }
      }
    },
  };
  public lineChartLegend = true;


  constructor(private userStepService: UserStepService) {}

  ngOnInit(): void {
    this.setChartData();

  }

  setChartData() {
    
    this.lineChartData.datasets[0].data = [];
    this.lineChartData.datasets[1].data = [];
    this.lineChartData.datasets[2].data = [];
    this.lineChartData.labels = [];
   
    // setup chart data
    this.weeksData.slice().reverse().forEach((weekData:any, weekNo:number) => {
      //console.log(weekData[0].date);
      this.lineChartData.labels?.push(
        weekNo+1
      );


        var vigorousMinutes = 0;
        var moderateMinutes = 0;
        var totalMinutes = 0;
        weekData.forEach((day:any) =>{
          totalMinutes += +day.minutes;
          moderateMinutes += day.moderateMinutes;
          vigorousMinutes += day.vigorousMinutes;
        });
      this.lineChartData.datasets[0].data.push(totalMinutes);
      this.lineChartData.datasets[1].data.push(moderateMinutes);
      this.lineChartData.datasets[2].data.push(vigorousMinutes);
    });
  }


}
